import React, { useState } from 'react';
import Icon from 'components/AppIcon';

export default function PasswordField({ label, value, onChange, placeholder, error, id }) {
  const [show, setShow] = useState(false);

  return (
    <div>
      <label htmlFor={id} className="block text-xs font-medium text-[var(--color-muted-foreground)] font-[var(--font-caption)] mb-1">
        {label}
      </label>
      <div className="relative">
        <input
          id={id}
          type={show ? 'text' : 'password'}
          value={value}
          onChange={(e) => onChange?.(e?.target?.value)}
          placeholder={placeholder}
          className={`w-full px-3 py-2.5 pr-10 rounded-[var(--radius-sm)] border text-sm font-[var(--font-body)] bg-[var(--color-input)] text-[var(--color-foreground)] transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-[var(--color-ring)]/30 focus:border-[var(--color-primary)] ${
            error ? 'border-[var(--color-error)]' : 'border-[var(--color-border)] hover:border-[var(--color-primary)]/40'
          }`}
        />
        <button
          type="button"
          onClick={() => setShow(s => !s)}
          className="absolute right-3 top-1/2 -translate-y-1/2 text-[var(--color-muted-foreground)] hover:text-[var(--color-foreground)] transition-colors"
          aria-label={show ? 'Hide password' : 'Show password'}
        >
          <Icon name={show ? 'EyeOff' : 'Eye'} size={16} color="currentColor" />
        </button>
      </div>
      {error && <p className="text-xs text-[var(--color-error)] mt-1 font-[var(--font-caption)]">{error}</p>}
    </div>
  );
}
